var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"cos-uploader",attrs:{"action":"#","show-file-list":false,"list-type":"picture-card","before-upload":_vm.beforeUpload}},[_vm._t("default",function(){return [_vm._v("上传文件")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }